import { useQuery } from '@tanstack/react-query';
import type { AgentApiAllianceSettingShow } from '@/types/serializers';

export const ALLIANCE_SETTING_QUERY_KEY = ['alliance_setting'] as const;

export default function useFetchAllianceSetting() {
  return useQuery({
    queryKey: ALLIANCE_SETTING_QUERY_KEY,
    queryFn: async () => {
      const response = await fetch('/agent/api/alliance_setting');
      if (!response.ok) {
        throw new Error('アライアンス設定の取得に失敗しました');
      }
      const data: AgentApiAllianceSettingShow = await response.json();
      return data;
    },
  });
}
